module.exports = __webpack_public_path__ + "static/media/collaborate-Wed_25.19efbd89.jpg";